import Requestor from '@/api/Requestor';
import { clientInstance } from '@/api/core';
// 매출
class SalesApi extends Requestor {
    /**
     * 허브 바로머니 데일리 매출 조회
     */
    getSalesHubBaromoneyDaily(params) {
        return this.get({
            url: '/api/sales/hub-baromoney/daily',
            params,
        });
    }
    /**
     * 허브 바로머니 월별 매출 조회
     */
    getSalesHubBaromoneyMonthly(params) {
        return this.get({
            url: '/api/sales/hub-baromoney/monthly',
            params,
        });
    }
    /**
     * 허브 바로머니 일별 상세 조회
     */
    getSalesHubBaromoneyDailyDetail(params) {
        return this.get({
            url: '/api/sales/hub-baromoney/daily-detail',
            params,
        });
    }
    /**
     * 매출 > 배송운임 조회
     */
    getDeliveryCharge(params) {
        return this.get({
            url: '/api/sales/delivery-charge',
            params,
        });
    }
    /**
     * 매출 > 사용내역서 조회
     */
    getUseHistory(params) {
        return this.get({
            url: '/api/sales/use-history',
            params,
        });
    }
    /**
     * 매출 > 상점 바로머니 조회
     */
    getSalesStoreBaromoney(params) {
        return this.get({
            url: '/api/sales/store-baromoney',
            params,
        });
    }
    /**
     * 매출 > 상점 바로머니 일별 상세 조회
     */
    getSalesStoreBaromoneyDailyDetail(params) {
        return this.get({
            url: '/api/sales/store-baromoney-daily-detail',
            params,
        });
    }
}
export const salesApi = new SalesApi(clientInstance);
